export default __webpack_public_path__ + "static/media/download.a29bbc98.svg";